import React from "react";

function PrivacyPage() {
  return (
    <section className="jh-container jh-section">
      <h1 className="jh-title">Privacy Policy</h1>
      <p className="jh-sub" style={{ maxWidth: 760, margin: "0 auto" }}>
        This Privacy Policy describes how Ridley Jewelry collects, uses, and
        shares your information when you browse our site or place an order.
      </p>

      <div style={{ maxWidth: 760, margin: "12px auto 0 auto" }}>
        <h2 className="jh-title" style={{ fontSize: 22, marginTop: 24 }}>
          Information we collect
        </h2>
        <div className="jh-note" style={{ marginTop: 8 }}>
          We collect information you provide during checkout such as your name,
          email address, shipping address, and order details. Payment details are
          processed by our payment providers and are not stored on our servers.
        </div>

        <h2 className="jh-title" style={{ fontSize: 22, marginTop: 24 }}>
          How we use information
        </h2>
        <div className="jh-note" style={{ marginTop: 8 }}>
          We use your information to fulfill orders, provide customer support,
          send order-related messages, and improve the shopping experience.
        </div>

        <h2 className="jh-title" style={{ fontSize: 22, marginTop: 24 }}>
          Sharing
        </h2>
        <div className="jh-note" style={{ marginTop: 8 }}>
          We share information only with service providers needed to operate the
          store and fulfill your order (for example, payment processing and
          shipping). We do not sell your personal information.
        </div>

        <h2 className="jh-title" style={{ fontSize: 22, marginTop: 24 }}>
          Contact
        </h2>
        <div className="jh-note" style={{ marginTop: 8 }}>
          Questions about privacy? Email support@ridleyjewelry.com.
        </div>
      </div>
    </section>
  );
}

export default PrivacyPage;
